import { apiError, loginSuccess, userAccessRightsSuccess, userProfileFetchSuccess } from "slices/auth/login/reducer";
import axiosInstance from "./common/axiosInstance";


export const loginApi = async (data: {
  username: string;
  password: string;

}) => {
  const response = await axiosInstance.post("/adminauth/adminlogin", data);
  return response.data;
};

export const changePasswordApi = async (data: {

          old_password: string;
        new_password: string;

}) => {
  try {
        console.log(data)

    const response = await axiosInstance.post(
      "/adminauth/changepassword",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const forgetPasswordApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/adminauth/forgetpasswordotp",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const resetPasswordApi = async (data: {
  otp: string;
  newpassword: string;
  username: string;  
}) => {
  try {
    const response = await axiosInstance.post(
      "/adminauth/confirmforgetpasswordotp",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const logoutApi = async () => {
  // const response = await axiosInstance.post("/auth/logout");
  // return response.data;
};

export const getLoggedinUser = async () => {
  // const response = await axiosInstance.get("/auth/me");
  // return response.data;
};

export const fetchLoggedInUser = () => async (dispatch: any) => {
  try {

    dispatch(loginSuccess());
    // const response = await getLoggedinUser();
    // const accessrights = response?.data?.useraccessrights


    // if (response?.success) {
    //   dispatch(userProfileFetchSuccess(response.data));
    //   dispatch(userAccessRightsSuccess(accessrights));
    // } else {
    //   dispatch(apiError({ data: "Failed to fetch user profile" }));
    // }
  } catch (error: any) {
    // dispatch(apiError({ data: error?.message || "Unexpected error" }));
  }
};



export const fetchAuditorListsApi = async (guid: string) => {
  try {
    // const response = await axiosInstance.post("/auth/fetchauditorslist", {
      // subroles: ["ds"],
    // });
    // return response.data;
  } catch (error: any) {
    // throw error.response?.data || error.message;
  }
};


export const getClientDataApi = async (params: Record<string, any>) => {
  // try {
  //   const response = await axiosInstance.get("/auth/vendordata", {
  //     params,
  //   });
  //   console.log("Response", response);
  //   return response.data;
  // } catch (error: any) {
  //   console.log("Error", error);
  //   throw error.response?.data || error.message;
  // }
};


